module.exports = __webpack_public_path__ + "img/sr-slide-deck.3c637392.png";